import { useState, useEffect } from "react";
import FinancialReportTab from "./FinancialReportTab";
import TourOrdersTab from "./TourOrdersTab";
import UserInformationTab from "./UserInformationTab";
import VisitReport from "./VisitReport";

import { getVisits, getProfileInfo } from "services/userReport";
import Helmet from "react-helmet";

export default function UserReport() {
  const [visitList, setVisitList] = useState([]);
  const [profileInfo, setProfileInfo] = useState([]);

  useEffect(() => {
    getVisits(4).then((value) => setVisitList(value));
    getProfileInfo(109).then((value) => setProfileInfo(value));
  }, []);
  return (
    <div className="user-report-container">
      {/* {UserReports.information && (
        <Helmet>
          <title>{UserReports.information.fname + " " + UserReports.information.lname + " | "} جمه صب</title>
        </Helmet>
      )} */}

      <div className=" d-flex flex-nowrap flex-row">
        <div className="ms-5">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item">
              <button class="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#user-information" type="button" role="tab" aria-controls="personnel" aria-selected="true">
                مشخصات فردی
              </button>
            </li>
            <li class="nav-item">
              <button class="nav-link" id="customers-tab" data-bs-toggle="tab" data-bs-target="#tour-orders" type="button">
                سفارشات تور
              </button>
            </li>

            <li class="nav-item">
              <button class="nav-link" id="customers-tab" data-bs-toggle="tab" data-bs-target="#ticket-orders" type="button">
                سفارشات بلیط
              </button>
            </li>

            <li class="nav-item">
              <button class="nav-link" id="customers-tab" data-bs-toggle="tab" data-bs-target="#shop-orders" type="button">
                سفارشات فروشگاه
              </button>
            </li>

            <li class="nav-item">
              <button class="nav-link" id="customers-tab" data-bs-toggle="tab" data-bs-target="#financial-report" type="button">
                گزارش مالی
              </button>
            </li>

            <li class="nav-item">
              <button class="nav-link" id="customers-tab" data-bs-toggle="tab" data-bs-target="#view-report" type="button">
                گزارش بازدید
              </button>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent">
            {/* <FinancialReportTab></FinancialReportTab> */}
            <TourOrdersTab></TourOrdersTab>
            <UserInformationTab profileInfo={profileInfo}></UserInformationTab>
            <VisitReport visitList={visitList}></VisitReport>
            <div class="tab-pane fade  " id="ticket-orders">
              این بخش فعال نیست.
            </div>
            <div class="tab-pane fade  " id="shop-orders">
              این بخش فعال نیست.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
